/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /**
   * @static @constant {number} The maximum number of products to store
   *
   * SỐ LƯU, KHÔNG PHẢI SỐ HIỆN. Hai con số này khác nhau và trước đây bị gộp làm một,
   * đó chính là lỗi: trang sản phẩm ghi id của CHÍNH NÓ vào localStorage ngay khi tải,
   * nên món đang xem chiếm mất một chỗ rồi lại bị loại lúc hiển thị. Lưu 5 thì trang
   * sản phẩm chỉ còn 4 để hiện — xem 6 hay 60 món cũng vẫn 4, vì đây là cửa sổ trượt
   * chứ không phải danh sách dồn thêm.
   *
   * Nên phải lưu nhiều hơn số muốn hiện đúng 1: 6 lưu − 1 món đang xem = 5 hiện.
   * Số muốn hiện nằm ở `MAX_VISIBLE` trong `recently-viewed-products-section.js`;
   * đổi bên đó thì đổi luôn số này thành MAX_VISIBLE + 1.
   *
   * Lịch sử: 4 → 5 (09/09/2026) cho khớp lưới 5 ô, → 6 (10/09/2026) khi phát hiện
   * trang sản phẩm luôn hụt một món.
   *
   * Ô tìm kiếm không bị ảnh hưởng: nó tự cắt còn 4 bằng tham số `limit` khi render
   * `predictive-search-products-list`.
   *
   * Lưu ý: khách cũ đã có sẵn 5 id trong máy, phải xem thêm một sản phẩm nữa mới đầy.
   */
  static #MAX_PRODUCTS = 6;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
  }
}
